import React from 'react'
import { ExternalLink, InternalLink } from '../../components/Library'

// An in-app route (`to`) or an external page (`href`), never both
type Destination = { to: string; href?: never } | { href: string; to?: never }

type Props = Destination & {
  title: string
  onClick: () => void
}

export const MenuListItem: React.FC<Props> = ({ title, to, href, onClick }) =>
  href !== undefined ? (
    <ExternalLink mb={1} href={href} onClick={onClick} onKeyPress={onClick}>
      {title}
    </ExternalLink>
  ) : (
    <InternalLink mb={1} to={to} onClick={onClick} onKeyPress={onClick}>
      {title}
    </InternalLink>
  )
